module.exports = __webpack_public_path__ + "static/media/downrow.d59a5d59.svg";